import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraStackedColumnChart } from '@mono/ui-components/captains';
import { SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { AwardScopeControl } from './AwardScopeControl';
import { awardMoney, awardsModel } from './awardsModel';
export function AwardsChart({ series, fy, scope, onScopeChange }) {
    const model = awardsModel(series, fy);
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraStackedColumnChart, {
                "data-testid": Testids.registryGovOrg.awardsChart,
                getColumnTestId: ()=>Testids.registryGovOrg.awardColumn,
                title: "What they've awarded · $M by award start year, by winner",
                description: series.sourceNote,
                columnLabel: "Fiscal year",
                segments: model.segments,
                columns: model.columns,
                format: awardMoney,
                insight: model.insight || undefined,
                actions: /*#__PURE__*/ _jsx(AwardScopeControl, {
                    scope: scope,
                    facets: series.facets,
                    onChange: onScopeChange
                }),
                emptyMessage: "No award values recorded for this office yet."
            }),
            model.empty && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Award values arrive from USAspending once the award feed is on for this workspace."
            }),
            series.unknownValueCount > 0 && /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: [
                    series.unknownValueCount,
                    " awards have no known value and are not counted."
                ]
            }),
            scope.preset !== 'all' && series.unclassifiedCount > 0 && /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: [
                    series.unclassifiedCount,
                    " awards have no NAICS or PSC and are not in this view."
                ]
            }),
            series.truncated && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Showing the first 2,000 tracked awards. Totals may be incomplete."
            })
        ]
    });
}
